export default function AboutSection() {
  return (
    <section id="sobre" className="w-full bg-nude py-16 md:py-24 relative overflow-hidden">
      {/* Colonial decorative corner */}
      <div className="absolute bottom-0 left-0 w-24 h-24 border-t border-r border-primary/10 rounded-tr-3xl" />
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-6xl mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
          {/* Text content */}
          <div className="flex-1">
            <p className="font-body text-xs tracking-[0.25em] uppercase text-primary mb-3">
              Sobre o Projeto
            </p>
            <h2 className="font-display text-2xl md:text-3xl lg:text-4xl text-brown mb-8 leading-snug">
              Nascemos da crença de que nenhuma mulher precisa caminhar sozinha
            </h2>

            <div className="space-y-5 font-body text-brown/85 text-base md:text-lg leading-relaxed">
              <p>
                <strong className="text-brown">
                  Entre Elas nasceu de um sonho simples: criar um lugar onde
                  mulheres pudessem se encontrar de verdade.
                </strong>{" "}
                Não para trocar cartões de visita, mas para trocar histórias,
                abraços, choro e risada.
              </p>
              <p>
                Acreditamos que a conexão feminina é uma força transformadora.
                Quando uma mulher se sente vista, ouvida e acolhida, algo
                desperta dentro dela. Ela se lembra do próprio valor. E a partir
                daí, tudo muda.
              </p>
              <p>
                Nossos encontros são espaços seguros para o crescimento espiritual,
                emocional e pessoal. Aqui, compartilhamos vulnerabilidades,
                celebramos conquistas e caminhamos lado a lado — com fé,
                propósito e muito amor.
              </p>
            </div>
          </div>

          {/* Side image */}
          <div className="w-full lg:w-[380px] flex-shrink-0">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="/img/readdy/ae3fe62be099.jpg"
                alt="Mulheres reunidas em círculo - algumas com alianças, simbolizando que mulheres casadas e solteiras caminham juntas"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}